var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';

/**
 * Get Styled Component option theme
 * @param options GetListboxThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getListboxTheme = function getListboxTheme(options) {
  var look = options.look;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-color: ", ";\n  "])), function (_ref) {
    var theme = _ref.theme;
    return theme.listbox[look].backgroundColor;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.listbox[look].borderColor;
  });
};
export { getListboxTheme };